import React from 'react';
import { SlaActivityHistoryWrapper } from './styled';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const SlaActivityHistory = ({ comment }) => {
  const commentedAt = format(
    new Date(comment.creation_date),
    `dd 'de' LLLL 'às' HH:mm`,
    {
      locale: ptBR
    }
  );
  return (
    <SlaActivityHistoryWrapper>
      {comment.description}
      <div id="sla_history-info-protocol-id">
        <span>{commentedAt}</span>
      </div>
    </SlaActivityHistoryWrapper>
  );
};

export default SlaActivityHistory;
